import PageScroller from './PageScroller'

export const comparePlansScroller = new PageScroller('compare-plans-scroller')
export const selectPlanScroller = new PageScroller('select-plan')
export const benefitsScroller = new PageScroller('benefits')
